<div class="modal-content">
    <div class="modal-header">
        <h4 class="modal-title fw-bold">{{ 'study-editor.sub-observation-unit-builder.type-selector.modal-header' | translate }}</h4>
        <button type="button" class="btn-close" (click)="cancel()"></button>
    </div>
    <div class="modal-body">
        <div class="row">
            <div class="col-xs-12 col-md-12">
                <span class="control-label font-weight-bold"><em> {{ 'study-editor.sub-observation-unit-builder.type-selector.create-subdivide-observation-question' | translate }}</em></span>
            </div>
        </div>
        <div class="row pt-2 pb-2">
            <div class="col-xs-11">
                <div *ngFor="let datasetType of subObservationInfoModels"><input class="form-check-input mb-1"
                                                                                 id="{{ 'datasetTypeSelector' + datasetType.id }}"
                                                                                 name="datasetTypeSelector"
                                                                                 type="radio" [value]="datasetType"
                                                                                 (click)="dataSetTypeSelected(datasetType)">
                    <label class="form-check-label ms-2 mb-1" [for]="'datasetTypeSelector' + datasetType.id">
                        {{ datasetType.label | translate | uppercase }}
                    </label>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="cancel()">
            {{ 'cancel' | translate }}
        </button>
        <button type="button" class="btn btn-primary ms-2" [disabled]="!selectedDatasetType"
                (click)="continue()"> {{ 'continue' | translate }}
        </button>
    </div>
</div>
